
import { defineComponent, PropType } from 'vue'
import { iKpi } from '../Scorecards'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { formatDate } from '@/helpers/commons/localeHelper'
import { getKpiIconColorClass } from '../ScorecardsHelpers'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import moment from 'moment'
import scorecardsKpiDialogDescriptor from './ScorecardsKpiDialogDescriptor.json'

export default defineComponent({
    name: 'scorecards-kpi-dialog',
    components: { Column, DataTable, Dialog },
    props: { visible: { type: Boolean }, propKpis: { type: Array as PropType<iKpi[]>, required: true }, selectedKpis: { type: Array as PropType<iKpi[]>, required: true } },
    emits: ['close', 'kpiSelected'],
    data() {
        return {
            scorecardsKpiDialogDescriptor,
            kpis: [] as iKpi[],
            filters: { global: [filterDefault] },
            selected: [] as iKpi[],
            getKpiIconColorClass
        }
    },
    watch: {
        visible(value) {
            if (value) this.loadSelectedKpi()
        },
        propKpis() {
            this.loadKpi()
        }
    },
    created() {
        this.loadKpi()
        this.loadSelectedKpi()
    },
    methods: {
        loadKpi() {
            this.kpis = this.propKpis ?? []
        },
        loadSelectedKpi() {
            this.selected = this.selectedKpis
        },
        getFormattedDate(date: number) {
            const tempDate = moment(date).format('DD/MM/YYYY')
            return formatDate(tempDate, '', 'DD/MM/YYYY')
        },
        closeDialog() {
            this.$emit('close')
            this.selected = []
        },
        save() {
            this.$emit('kpiSelected', this.selected)
        }
    }
})
